const CleaningManagement = "";
const DigitalCleaningPlatform = "DCP";

const Source = {
  CleaningManagement,
  DigitalCleaningPlatform,
};

export default Source;
